import { GuestUnitDetailsScreenMobile } from '@/modules/guest';

/** Mobile guest unit details — `/guest-home-details?id=` */
export default function GuestHomeDetailsRoute() {
  return <GuestUnitDetailsScreenMobile />;
}
